/**
 * Created by Gaurav on 18/OCT/2019.
 */

import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Linear, TweenLite} from "gsap";
import {BarbarianFuryReelSymbol} from "../symbols/BarbarianFuryReelSymbol";

export abstract class BurningReelSymbol extends BarbarianFuryReelSymbol {

    protected _fireOverlay:TimelineSprite;
    protected _roarOverlay:TimelineSprite;
    private isPlayingFire:boolean;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    public setVisibility(value:boolean):void {
        super.setVisibility(value);

        if(this.visible && this.isPlayingFire) {
            this.playFireOverlay(false);
        } else {
            this.stopFireOverlay(0);
        }
    }

    public playFireOverlay(playSound:boolean = true):void {
        this.isPlayingFire = true;
        if(!this.visible) {
            return;
        }

        if(!this._fireOverlay) {
            this._fireOverlay = this.createSpinningFireOverlay();
            this.addChildAt(this._fireOverlay, 0);
            // #70
            if(this.symName.split("*")[0] === "W") {
                this.addChild(this._fireOverlay);
            }
        }

        this._fireOverlay.show();
        this._fireOverlay.playLoop();

        // move the current reel to the top of all reels.
        /*const reelView: PIXI.DisplayObject = this.parent;
        if (reelView) {
            reelView.parent.addChild(reelView);
        }*/

        if(playSound && this.playFireSound) {
            this.playFireSound();
        }
    }

    public stopFireOverlay(duration:number, playRoarAnim:boolean | null = false, reelId:number | null = null, stopFireOverlay = false):void {
        if(this.reelId !== reelId) {
            return;
        }
        this.isPlayingFire = false;


        if(playRoarAnim || stopFireOverlay) {
            if(!this._roarOverlay) {
                this._roarOverlay = this.createLandingFireOverlay();

                // To move the patches always on the top.
                this.addChild(this._roarOverlay);
            }
            if(!this._fireOverlay) { // causing error when fast click in case wild lands...need to discuss.
                return;
            }
            this._fireOverlay.hide();
            this._roarOverlay.getAnimationAutoShowHide(true, true);
            TweenLite.to(this._roarOverlay, duration, {
                alpha : 1,
                onComplete : () => {
                    !stopFireOverlay && this._fireOverlay.show();
                    if(this._fireOverlay.transform !== null) {
                        if(this.symName.split("*")[0] === "W") {
                            TweenLite.to(this._fireOverlay.scale, 1, {
                                x : 1,
                                y : 1,
                                delay : 0,
                                ease : Linear.easeInOut
                            })
                        } else {
                            TweenLite.to(this._fireOverlay.scale, 1, {
                                x : 0.85,
                                y : 0.95,
                                delay : 0,
                                ease : Linear.easeInOut
                            })
                        }
                    }
                }
            });
        }
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            // To move the patches always on the top.
            if(this._fireOverlay) {
                this.addChildAt(this._fireOverlay, 0);

                // #70
                if(this.symName.split("*")[0] === "W") {
                    this.addChild(this._fireOverlay);
                }
            }

            if(this._roarOverlay) {
                this.addChild(this._roarOverlay);
            }

            return true;
        }

        return false;
    }

    protected reset(remove:boolean):void {
        super.reset(remove);
        this.stopFireOverlay(0);
    }

    protected playFireSound?():void;

    protected abstract createSpinningFireOverlay():TimelineSprite;

    protected createLandingFireOverlay():TimelineSprite {
        const scatterLandingFire:TimelineSprite = new TimelineSprite(GameResources.getTextures("scatterLandingFire"), 32);
        scatterLandingFire.anchor.set(0.5, 0.5);
        scatterLandingFire.position.set(0, 0);
        scatterLandingFire.scale.set(1, 1);
        return scatterLandingFire;
    }
}